import * as React from "react";
import {BookingOptions,} from "./booking/booking";
import {BookingApp} from "./booking/BookingApp";
import {FreeApp} from "./free/FreeApp";
import {ThemeProvider, useStorageItem} from "@variocube/cube-ui";

export function SafeCubeShell() {
    const {loading, result: bookingOptions} = useStorageItem<BookingOptions>("bookingOptions");

    console.log("SafeCubeShell", {loading, bookingOptions});

    // don't display anything, if we don't know yet, what UI to show
    if (!bookingOptions && loading) {
        return null;
    }

    const app = (bookingOptions && bookingOptions.enableBooking)
        ? <BookingApp />
        : <FreeApp />;

    return (
        <ThemeProvider defaultTheme={defaultTheme}>
            {app}
        </ThemeProvider>
    )
}

const defaultTheme = {
    colorBackground: "#444",
    colorPrimary: "#f18721",
    colorChoice: "#21c4f1",
    colorSeparator: "#fff",
    colorInputBackground: "#fff",
    colorForeground: "#fff",
}